import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
export default class CustomValidators {
  static match(controlName: string, matchControlName: string): ValidatorFn {
    return (controls: AbstractControl) => {
      const control = controls.get(controlName);
      const matchControl = controls.get(matchControlName);

      if (!matchControl?.errors && control?.value !== matchControl?.value) {
        matchControl?.setErrors({
          matching: {
            actualValue: matchControl?.value,
            requiredValue: control?.value
          }
        });
        return { matching: true };
      } else {
        return null;
      }
      return null;
    };
  }

  static newPasswordSameAsOld(controlName: string, otherControlName: string, anotherControlName: string): ValidatorFn {
    return (controls: AbstractControl) => {
      const control = controls.get(controlName);
      const otherControl = controls.get(otherControlName);
      const anotherControl = controls.get(anotherControlName);
      if (control?.value === '') {
        control.setErrors({ required: true });
        return { required: true };
      }
      if (
        control?.value.toLowerCase() === otherControl?.value.toLowerCase() &&
        control?.value.toLowerCase() === anotherControl?.value.toLowerCase()
      ) {
        control.setErrors({ sameAsOld: true });
        return { sameAsOld: true };
      }
      return null;
    };
  }

  static containsSpecialRequirementsValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> => {
      const value = control.value;
      if (!value) {
        return Promise.resolve(null);
      }

      const hasLowercase = /[a-z]/.test(value);
      const hasUppercase = /[A-Z]/.test(value);
      const hasDigit = /\d/.test(value);
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

      const conditionsMet = [hasLowercase, hasUppercase, hasDigit, hasSpecialChar].filter(Boolean).length;

      if (value.length < 10 || conditionsMet < 3) {
        return Promise.resolve({ atLeastThreeAndMinLength: true });
      }

      return Promise.resolve(null);
    };
  }
}
